export default "__VITE_ASSET__CT$7IIxK__"